import { isNil } from 'lodash';

export function emptyDefault<V>(
  value: V | null | undefined,
  defaultValue: Exclude<V, null | undefined>
): V {
  return isNil(value) || value === '' ? defaultValue : value;
}
